import { connect } from 'react-redux';
import ActiveBets from '../../../components/betslip/ActiveBets/ActiveBets';

import {
  updateOfferByUser,
  submitEditedOffersByIds,
  submitEditedUnmatchedByIds,
  reviewOpenOffer,
  cancelOpenOffersByIds,
  cancelUnmatchedOpenOffersByIds,
  setActiveFilters,
  requestPaginatedData
} from '@xanadu/ui-shared/modules/openOffers/actions';

const mapDispatchToProps = {
  onUpdateOffers: updateOfferByUser,
  onReviewOffer: reviewOpenOffer,
  onSubmitOffers: submitEditedOffersByIds,
  onSubmitUnmatched: submitEditedUnmatchedByIds,
  onCancelOffers: cancelOpenOffersByIds,
  onCancelUnmatchedOffers: cancelUnmatchedOpenOffersByIds,
  setActiveFilters,
  requestPaginatedData,
};


const mapStateToProps = (state) => ({
  tourMode: state.getIn(['customerOnboarding', 'tourMode']),
  openOffers: state.getIn(['openOffers', 'data']),
  fakeOpenOffers: state.getIn(['openOffers', 'fakeData']),
  currency: state.getIn(['user', 'currency']),
  activeSports: state.getIn(['openOffers', 'activeSports']),
  activeFilters: state.getIn(['openOffers', 'activeFilters']),
  aggregationRule: state.getIn(['openOffers', 'aggregationRule']),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveBets);
